import { Gallery } from "../Gallery/Gallery";
import { Subheading } from "../Subheading/Subheading";
import Counter from "../ui/Counter/Counter";
import { Heading } from "../ui/Heading/Heading";

export default function Impact() {
  const impactMetrics = [
    {
      metric: 1,
      suffix: "M+",
      label: "People Impacted",
    },
    {
      metric: 100,
      suffix: "+",
      label: "Interactions Carried",
    },
    {
      metric: 100,
      suffix: "%",
      label: "Satisfaction Rate",
    },
  ];

  return (
    <div
      id="award"
      className="relative mt-24 h-screen flex flex-col items-center"
    >
      <div className="absolute">
        <Gallery />
      </div>

      <div className="z-10 w-full h-full">
        <Heading placeholder="Impact" subheading="The Impact we made" />
        <div className="md:flex hidden flex-col justify-center items-center gap-15 text-white p-3 sm:p-5 h-[80vh] font-gilroy-medium">
          <div className="flex flex-row justify-between w-full px-10 md:p-0 md:w-4/5 gap-8 md:gap-0 mb-20">
            <div className="flex flex-col justify-center items-start w-full md:w-1/2 gap-3 md:gap-5">
              <Subheading
                placeholder="We create lasting impressions and memorable experiences."
                size="md"
                fontIndex={[2, 5]}
                speed={["start 1", "start 0.50"]}
              />
            </div>
            <div className="flex flex-col items-end w-full md:w-1/2 z-10">
              {impactMetrics.map((impactMetric, index) => (
                <div key={index} className="text-left w-[160px] mb-3 md:mb-5">
                  <div className=" flex ">
                    <Counter
                      number={impactMetric.metric}
                      duration={2}
                      className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-gilroy-medium"
                    />
                    <div className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-gilroy-medium ml-2">
                      {impactMetric.suffix}
                    </div>
                  </div>
                  <p className="m-0 text-sm sm:text-base text-white">
                    {impactMetric.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="flex md:hidden w-full h-full flex-col justify-center items-center gap-10 py-10">
          {impactMetrics.map((impactMetric, index) => {
            return (
              <div
                key={index}
                className="flex flex-col font-gilroy-light text-[24px] justify-center items-center leading-12"
              >
                <label className="text-[72px] flex justify-center items-center">
                  <Counter
                    number={impactMetric.metric}
                    duration={2}
                    className=""
                  />
                  {impactMetric.suffix}
                </label>
                <label className="font-gilroy-medium">
                  <span className="font-nyght-serif-medium-italic">
                    {impactMetric.label}
                  </span>{" "}
                </label>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
